<template>
  <div class="space-y-4">
    <h2 class="text-2xl font-bold text-center mb-6">{{ $t('resetYourPassword') }}</h2>
    
    <form @submit.prevent="handleSubmit" class="space-y-4">
      <div>
        <input 
          v-model="password"
          type="password" 
          :placeholder="$t('newPassword')"
          required
          class="appearance-none rounded-[32px] relative block w-full px-3 py-2 h-14 border border-[#e6e6e6] placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
        />
      </div>
      
      <div>
        <input 
          v-model="confirmPassword"
          type="password" 
          :placeholder="$t('confirmPassword')"
          required
          class="appearance-none rounded-[32px] relative block w-full px-3 py-2 h-14 border border-[#e6e6e6] placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
        />
      </div>

      <button 
        type="submit"
        class="w-full flex justify-center items-center py-2 px-4 border border-transparent text-sm font-medium rounded-[32px] h-14 text-white bg-main hover:contrast-150 focus:outline-none focus:ring-0"
        :disabled="loading"
      >
        <span v-if="loading" class="spinner-loading"></span>
        <span v-else>{{ $t('resetPassword') }}</span>
      </button>
    </form>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { showSuccess, showError } from '../../utils/swal'
import { t } from '../../utils/translate'

const props = defineProps({
  resetKey: {
    type: String,
    required: true
  },
  resetLogin: {
    type: String,
    required: true
  }
})

const smsir = window.sms_ir_login || {}
const $ = window.jQuery

const password = ref('')
const confirmPassword = ref('')
const loading = ref(false)

const handleSubmit = async () => {
  try {
    if (password.value !== confirmPassword.value) {
      showError(t('passwordsDoNotMatch'))
      return
    }

    loading.value = true

    const data = {
      action: 'smsir_reset_password',
      key: props.resetKey,
      login: props.resetLogin,
      password: password.value,
      nonce: smsir.nonce
    }

    const response = await $.post(smsir.ajaxUrl, data)

    if (response.success) {
      showSuccess(response.data.message || t('passwordResetSuccess'))
      setTimeout(() => {
        window.location.href = response.data.redirect_url || '/'
      }, 1500)
    } else {
      throw new Error(response.data?.message || t('generalError'))
    }
  } catch (err) {
    showError(err.message || t('generalError'))
  } finally {
    loading.value = false
  }
}
</script> 